<form *ngIf="formGroup" [formGroup]="formGroup">
  <div fxLayout="column" fxLayoutAlign="center stretch">

    <h4 class="fd-subtitle">Deseja habilitar funcionalidades extras do E-commerce</h4>

    <div *ngFor="let item of extraFunctionalitiesList" class="checkbox-container">
      <mat-checkbox
        (change)="onExtraFunctionalitiesCheckboxChange(item, $event)"
        [value]="item.value"
        [checked]="item.selected"
        class="fd-checkbox"
        [id]="item.value"
        >{{ item.label }}</mat-checkbox
      >
    </div>

    <h4 class="fd-subtitle">Informe a URL ou Rede Sociais na qual o estabelecimento expõe seus produtos ou serviços</h4>
    <div>
      <fd-input (blur)="validateUrl($event)" [parentForm]="formGroup" [field]="fields.link"> </fd-input>
    </div>

    <div class="tooltip-container">
      <h4 class="tooltip-subtitle fd-subtitle">Descreva qual tipo de produto/serviço será comercializado:</h4>
      <fa-icon
        matTooltipClass="fd-input__tooltip-dialog"
        class="tooltip-icon"
        icon="info-circle"
        size="1x"
        mat-button
        [matTooltip]="getGatewayTooltipText()"
        #tooltip="matTooltip"
        (click)="showTooltipAndStopPropagation()"
      >
      </fa-icon>
    </div>

    <div>
      <fd-input [parentForm]="formGroup" [field]="fields.productOrServiceDetails"> </fd-input>
    </div>

    <h4 class="fd-subtitle">Descreva como serão entregues os produtos adquiridos à distância:</h4>
    <div>
      <fd-input [parentForm]="formGroup" [field]="fields.describeHowWillBeDelivered"> </fd-input>
    </div>

    <h4 class="fd-subtitle">Informe o valor máximo esperado por transação</h4>
    <div>
      <fd-currency-input [parentForm]="formGroup" [field]="fields.maxValueOfTransaction"> </fd-currency-input>
    </div>

    <h4 class="fd-subtitle">Estabelecimento possui antifraude de terceiros contratado?</h4>
    <div>
      <fd-radio-button [yesOrNotOptions]="true" [parentForm]="formGroup" [field]="fields.hasAntiFraudService"> </fd-radio-button>
    </div>

    <h4 class="fd-subtitle">
      Estabelecimento ficou ciente dos riscos de transações sem a presença fisica do cartão e que em caso de contestação de vendas,
      <strong>há risco de não recebimento pela venda contestada?</strong>
    </h4>
    <div>
      <fd-radio-button [yesOrNotOptions]="true" [parentForm]="formGroup" [field]="fields.transactionRiskAware"> </fd-radio-button>
    </div>
  </div>
  <div class="button-container">
    <fd-button fdSecondary [content]="'cancelar'" (trigger)="back()"> </fd-button>
    <fd-button [content]="'avançar'" (trigger)="next()"> </fd-button>
  </div>
</form>
